module.exports = __webpack_public_path__ + "static/media/A7S01273.5f9979d0.jpg";